export const grunderwerbsteuerRates = {
  baden_wuerttemberg: { label: 'Baden-W\u00fcrttemberg', labelEN: 'Baden-W\u00fcrttemberg', rate: 0.050 },
  bayern: { label: 'Bayern', labelEN: 'Bavaria', rate: 0.035 },
  berlin: { label: 'Berlin', labelEN: 'Berlin', rate: 0.060 },
  brandenburg: { label: 'Brandenburg', labelEN: 'Brandenburg', rate: 0.065 },
  bremen: { label: 'Bremen', labelEN: 'Bremen', rate: 0.055 },
  hamburg: { label: 'Hamburg', labelEN: 'Hamburg', rate: 0.055 },
  hessen: { label: 'Hessen', labelEN: 'Hesse', rate: 0.060 },
  mecklenburg_vorpommern: { label: 'Mecklenburg-Vorpommern', labelEN: 'Mecklenburg-Western Pomerania', rate: 0.060 },
  niedersachsen: { label: 'Niedersachsen', labelEN: 'Lower Saxony', rate: 0.050 },
  nordrhein_westfalen: { label: 'Nordrhein-Westfalen', labelEN: 'North Rhine-Westphalia', rate: 0.065 },
  rheinland_pfalz: { label: 'Rheinland-Pfalz', labelEN: 'Rhineland-Palatinate', rate: 0.050 },
  saarland: { label: 'Saarland', labelEN: 'Saarland', rate: 0.065 },
  sachsen: { label: 'Sachsen', labelEN: 'Saxony', rate: 0.055 },
  sachsen_anhalt: { label: 'Sachsen-Anhalt', labelEN: 'Saxony-Anhalt', rate: 0.050 },
  schleswig_holstein: { label: 'Schleswig-Holstein', labelEN: 'Schleswig-Holstein', rate: 0.065 },
  thueringen: { label: 'Th\u00fcringen', labelEN: 'Thuringia', rate: 0.050 },
};

export const notarFeeTable = [
  { bisEUR: 50000, gebEUR: 165 },
  { bisEUR: 100000, gebEUR: 264 },
  { bisEUR: 125000, gebEUR: 300 },
  { bisEUR: 150000, gebEUR: 340 },
  { bisEUR: 200000, gebEUR: 435 },
  { bisEUR: 250000, gebEUR: 510 },
  { bisEUR: 300000, gebEUR: 635 },
  { bisEUR: 350000, gebEUR: 685 },
  { bisEUR: 400000, gebEUR: 735 },
  { bisEUR: 500000, gebEUR: 935 },
  { bisEUR: 600000, gebEUR: 1095 },
  { bisEUR: 750000, gebEUR: 1335 },
  { bisEUR: 1000000, gebEUR: 1735 },
];

export const notarVatRate = 0.19;

export const maklerRates = {
  bayern: { buyerShare: 0.0357 },
  baden_wuerttemberg: { buyerShare: 0.0357 },
  berlin: { buyerShare: 0.0357 },
  brandenburg: { buyerShare: 0.0357 },
  bremen: { buyerShare: 0.0298 },
  hamburg: { buyerShare: 0.0312 },
  hessen: { buyerShare: 0.0298 },
  mecklenburg_vorpommern: { buyerShare: 0.0298 },
  niedersachsen: { buyerShare: 0.0298 },
  nordrhein_westfalen: { buyerShare: 0.0357 },
  rheinland_pfalz: { buyerShare: 0.0357 },
  saarland: { buyerShare: 0.0357 },
  sachsen: { buyerShare: 0.0357 },
  sachsen_anhalt: { buyerShare: 0.0357 },
  schleswig_holstein: { buyerShare: 0.0357 },
  thueringen: { buyerShare: 0.0357 },
};

function lookupTabelleB(amount) {
  for (const row of notarFeeTable) {
    if (amount <= row.bisEUR) return row.gebEUR;
  }
  return notarFeeTable[notarFeeTable.length - 1].gebEUR;
}

export function calculateKaufnebenkosten(bundesland, purchasePrice, loanAmount = 0) {
  const grestRate = grunderwerbsteuerRates[bundesland]?.rate || 0.05;
  const grunderwerbsteuer = purchasePrice * grestRate;

  const baseFee = lookupTabelleB(purchasePrice);
  const beurkundung = baseFee * 2.0;
  const vollzug = baseFee * 0.5;
  const betreuung = baseFee * 0.5;
  const notarSubtotal = (beurkundung + vollzug + betreuung) * (1 + notarVatRate);

  const loanFee = loanAmount > 0 ? lookupTabelleB(loanAmount) * 1.0 * (1 + notarVatRate) : 0;
  const notar = notarSubtotal + loanFee;

  const gbBaseFee = lookupTabelleB(purchasePrice);
  const vormerkung = gbBaseFee * 0.5;
  const umschreibung = gbBaseFee * 1.0;
  const grundschuldEintragung = loanAmount > 0 ? lookupTabelleB(loanAmount) * 1.0 : 0;
  const grundbuch = vormerkung + umschreibung + grundschuldEintragung;

  const maklerRate = maklerRates[bundesland]?.buyerShare || 0.0357;
  const makler = purchasePrice * maklerRate;

  const total = grunderwerbsteuer + notar + grundbuch + makler;

  return { grunderwerbsteuer, notar, grundbuch, makler, total };
}
